export default __webpack_public_path__ + "static/media/elephant@3x.1d545b51.png";